import { ALLIANCE_BUFF_CATALOG } from "./allianceBuffCatalog";
import { ITEM_BUFF_CATALOG } from "./itemBuffCatalog";
import { CITY_DECORATION_TEMPORARY_BUFFS } from "./cityDecorationCatalog";
import { NATION_BUFF_CATALOG } from "./nationBuffCatalog";
import { DESIGNATION_BUFF_CATALOG } from "./designationBuffCatalog";
import { COMMANDER_SKILL_BUFF_CATALOG } from "./commanderSkillBuffCatalog";

const normalizeEffect = (effect = {}) => {
  const effectId = Math.trunc(Number(effect?.effectId || 0));
  const value = Number(effect?.value || 0);
  if (!Number.isFinite(effectId) || effectId <= 0 || !Number.isFinite(value) || value === 0) return null;
  return { effectId, value };
};

const normalizeDurationOption = (option = {}) => ({
  level: Math.max(0, Math.floor(Number(option?.level || 0))),
  durationSeconds: Math.max(0, Math.floor(Number(option?.durationSeconds || 0))),
  durationLabel: String(option?.durationLabel || "").trim(),
  quality: Math.max(0, Math.floor(Number(option?.quality || 0))),
  effects: (Array.isArray(option?.effects) ? option.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromItemBuff = (buff = {}) => ({
  buffId: `item:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "item",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: "itemBuff",
  categoryLabel: "Item Buffs",
  description: String(buff?.description || "").trim(),
  durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : []).map(normalizeDurationOption),
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromAllianceBuff = (buff = {}) => ({
  buffId: `alliance:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "alliance",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: String(buff?.category || "allianceBuff").trim(),
  categoryLabel: "Alliance Buffs",
  description: String(buff?.description || "").trim(),
  durationOptions: [{
    level: 0,
    durationSeconds: Math.max(0, Math.floor(Number(buff?.durationSeconds || 0))),
    durationLabel: String(buff?.durationLabel || "").trim(),
    quality: 0,
    effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
  }],
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromCityDecorationBuff = (buff = {}) => ({
  buffId: `cityDecoration:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "cityDecoration",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: String(buff?.category || "cityDecoration").trim(),
  categoryLabel: String(buff?.categoryLabel || "City Decorations").trim(),
  description: String(buff?.description || "").trim(),
  durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : []).map(normalizeDurationOption),
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromNationBuff = (buff = {}) => ({
  buffId: `nation:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "nation",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: String(buff?.category || "nation").trim(),
  categoryLabel: String(buff?.categoryLabel || "Nation").trim(),
  description: String(buff?.description || "").trim(),
  durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : []).map(normalizeDurationOption),
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromDesignationBuff = (buff = {}) => ({
  buffId: `designation:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "designation",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: String(buff?.category || "designation").trim(),
  categoryLabel: String(buff?.categoryLabel || "Designations").trim(),
  description: String(buff?.description || "").trim(),
  durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : []).map(normalizeDurationOption),
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

const fromCommanderSkillBuff = (buff = {}) => ({
  buffId: `commanderSkill:${Math.trunc(Number(buff?.itemGid || 0))}`,
  sourceType: "commanderSkill",
  itemGid: Math.trunc(Number(buff?.itemGid || 0)),
  name: String(buff?.name || "").trim(),
  category: String(buff?.category || "commanderAndBreakthroughSkills").trim(),
  categoryLabel: String(buff?.categoryLabel || "Commander & Breakthrough Skills").trim(),
  description: String(buff?.description || "").trim(),
  durationOptions: (Array.isArray(buff?.durationOptions) ? buff.durationOptions : []).map(normalizeDurationOption),
  effects: (Array.isArray(buff?.effects) ? buff.effects : []).map(normalizeEffect).filter(Boolean),
});

export const TEMPORARY_BUFF_CATALOG = [
  ...(Array.isArray(ITEM_BUFF_CATALOG) ? ITEM_BUFF_CATALOG.map(fromItemBuff) : []),
  ...(Array.isArray(ALLIANCE_BUFF_CATALOG) ? ALLIANCE_BUFF_CATALOG.map(fromAllianceBuff) : []),
  ...(Array.isArray(CITY_DECORATION_TEMPORARY_BUFFS) ? CITY_DECORATION_TEMPORARY_BUFFS.map(fromCityDecorationBuff) : []),
  ...(Array.isArray(NATION_BUFF_CATALOG) ? NATION_BUFF_CATALOG.map(fromNationBuff) : []),
  ...(Array.isArray(DESIGNATION_BUFF_CATALOG) ? DESIGNATION_BUFF_CATALOG.map(fromDesignationBuff) : []),
  ...(Array.isArray(COMMANDER_SKILL_BUFF_CATALOG) ? COMMANDER_SKILL_BUFF_CATALOG.map(fromCommanderSkillBuff) : []),
].filter((buff) => buff.itemGid > 0 && buff.name && buff.effects.length > 0);

export default TEMPORARY_BUFF_CATALOG;
